module.exports = __webpack_public_path__ + "static/media/silver-member-desktop.14a7ef3d.svg";